import { styled, blurBehindMixin } from "../../../styled-components";

export const BackgroundStyle = styled.div<{ translateAmount: number }>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    pointer-events: auto;

    transform: translateY(${p => p.translateAmount}px);

    background-color: ${p => p.theme.navBar.bgColor};
    box-shadow: inset -1px 0 0 ${p => p.theme.separatorColor};

    ${p =>
        blurBehindMixin({
            backgroundColor: p.theme.navBar.transparentBgColor,
            fadeTo: p.theme.navBar.fadeTo,
        })};
`;
